import { toast } from 'sonner'
import { useTranslate } from 'shared/lib/i18n'
import { cn } from 'shared/lib/utils'

export function CopyChip({
	value,
	label,
	toastText,
	className,
}: {
	value: string
	label?: string
	toastText?: string
	className?: string
}) {
	const { t } = useTranslate()
	return (
		<button
			type='button'
			className={cn(
				'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-mono',
				'active:opacity-60',
				className,
			)}
			onClick={(e) => {
				e.stopPropagation()
				navigator.clipboard?.writeText(value)
				toast.success(toastText ?? t('common.copied'))
			}}
		>
			{label ?? value}
		</button>
	)
}
